import { graphql } from "react-relay";

export const EDIT_LEARN_START_DATE_MUTATION = graphql`
	mutation editLearnStartDateButton_EditLearnStartDateMutation($input: EditLearnStartDateInput!) {
		Admin {
			LearnProgress {
				editLearnStartDate(input: $input) {
					clientMutationId
				}
			}
		}
	}
`;

export const TREE_STATE_MINIMAL_FRAGMENT = graphql`
	fragment editLearnStartDateButton_TreeStateFragment on TreeState {
		id
		startedAt
	}
`;
